<template>
  <div>
    <div
      class="search"
      v-if="includeArticles"
    >
      <FontAwesomeIcon
        icon="search"
        class="search__input__icon"
        size="2x"
      />
      <input
        v-focus
        class="search__input"
        placeholder="recherche"
        @input="setSearchString"
      >
    </div>
    <div class="title">
      PLAN DE VENTE
    </div>
    <div class="tree">
      <ul class="node-list">
        <PlanVenteTreeNode
          v-for="node of planVente"
          :key="node.codeFamille"
          :node="node"
          @planVenteClicked="planVenteClicked"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PlanVenteTreeNode from './PlanVenteTreeNode'
export default {
  components: {
    PlanVenteTreeNode
  },
  computed: {
    ...mapGetters(['planVente', 'includeArticles'])
  },
  methods: {
    ...mapActions(['setSearchString']),
    planVenteClicked(selection) {
      this.$emit('planVenteClicked', selection)
    }
  }
}
</script>

<style scoped>
.tree {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
}

.title {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  align-self: center;
  font-weight: bold;
}

.node-list {
  margin: 0;
  padding: 0;
}

.search {
  display: inline-flex;
  width: 100%;
  margin-top: 1rem;
}

.search__input__icon {
  height: 1.1rem;
  padding: 0.1em;
  color: white;
  background-color: gray;
}

.search__input {
  width: 80%;
  padding: 0.15rem 0.3rem;
}
</style>
